var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"centered-input",attrs:{"value":_vm.copy,"name":"pix-key","autofocus":"","label":"Chave pix (Copia e cola)","append-icon":'mdi-content-copy',"persistent-hint":"","hint":_vm.pix_name ? `Recebedor: ${_vm.pix_name}` : null,"readonly":"","counter":""},on:{"click":_vm.copyToClipboard,"click:append":_vm.copyToClipboard}})
}
var staticRenderFns = []

export { render, staticRenderFns }